const PrimaryButton = ({
  children,
  isLoading,
  disabled,
  type = "button",
  icon: Icon,
}) => (
  <button
    type={type}
    disabled={disabled || isLoading}
    className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-[#1233CC] to-[#00BAFF] text-white py-3 rounded-lg shadow-md shadow-blue-100 hover:opacity-90 transition disabled:opacity-60 disabled:cursor-not-allowed"
  >
    {isLoading ? (
      "Processing..."
    ) : (
      <>
        {Icon && <Icon size={18} />}
        {children}
      </>
    )}
  </button>
);
export default PrimaryButton;
